import { Component,OnInit } from '@angular/core';
import { RecipientCriptoService } from '../../services/recipient-cripto.service';
import { TransferenciasUSDT } from '../../interfaces/transferencia-usdt.interface';
import { MatDialog } from '@angular/material/dialog';
import { RejectTransactionModalComponent } from '../assigned-transactions/reject-transaction-modal/reject-transaction-modal.component';
import {Clipboard} from '@angular/cdk/clipboard';
import Swal from 'sweetalert2';
import { getColumns,displayedColumns } from './table-transaction-zelle-columns';
import { CurrencyPipe } from '@angular/common';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { SendTransactionsZelleModalComponent } from './send-transactions-zelle-modal/send-transactions-zelle-modal.component';
import { EditZelleTransactionComponent } from './edit-zelle-transaction/edit-zelle-transaction.component';
import { RecipientZelleService } from '../../services/recipient-zelle.service';
import { BanksService } from '../../services/banks.service';

@Component({
  selector: 'app-pending-transactions-zelle',
  templateUrl: './pending-transactions-zelle.component.html',
  styleUrls: ['./pending-transactions-zelle.component.sass']
})
export class PendingTransactionsZelleComponent implements OnInit{

  public transactionsZelle: TransferenciasUSDT[] = [];
  displayedColumns = displayedColumns;
  columns = getColumns(this.currencyPipe);
  filteredTransactionCripto: TransferenciasUSDT[] = [];
  backTransactionCripto: TransferenciasUSDT[] = [];
  filterValue: string = '';
  monthlyLimits: any[] = [];
  limits: any[] = [];
  public currentPage = 1;
  public pageSize = 25;
  public totalItems = 0;
  public totalPages = this.totalItems/this.pageSize;
  expandedCardId: number | null = null;
  showBalances = false;

  constructor(
    private recipientzelleservice:RecipientZelleService,
    private dialog: MatDialog,
    private clipboard: Clipboard,
    private currencyPipe:CurrencyPipe,
    private spinner: SpinnerService,
    private bankService: BanksService
    ){}

  async ngOnInit() {
    this.loadTransactions();



  }

  async loadAccountsBalances(){
    this.limits = [];
    const zelleBalance = await this.bankService.getZelleBalance();
    for (let limit of zelleBalance.workingAccounts) {
        const dailyLimitZelle = zelleBalance.dailyBalance.find((dailyLimit: any) => dailyLimit.id === limit.cuenta_trabajo_id && dailyLimit.destino === 22) ;
        const dailyLimitBofa = zelleBalance.dailyBalance.find((dailyLimit: any) => dailyLimit.id === limit.cuenta_trabajo_id && dailyLimit.destino === 21) ;

        const monthlyLimitZelle = zelleBalance.monthlyBalance.find((monthlyLimit: any) => monthlyLimit.id === limit.cuenta_trabajo_id && monthlyLimit.destino === 22);
        const monthlyLimitBofa = zelleBalance.monthlyBalance.find((monthlyLimit: any) => monthlyLimit.id === limit.cuenta_trabajo_id && monthlyLimit.destino === 21);
        this.limits.push({
          ...limit,
          dailyLimitZelle,
          dailyLimitBofa,
          enviadoMensualBofa: monthlyLimitBofa?.total_monto_enviado ?? 0,
          enviadoMensualZelle: monthlyLimitZelle?.total_monto_enviado ?? 0,
        });

      }

  }

  async loadTransactions(): Promise<void> {
      const ref = this.spinner.start();
      const data = await this.recipientzelleservice.getTransactionZelle(this.currentPage,this.pageSize);
      await this.loadAccountsBalances();
      this.transactionsZelle = data.query;
      this.backTransactionCripto = data.query;
      this.totalItems = +data.count;
      this.totalPages = Math.ceil (this.totalItems/this.pageSize);
      this.spinner.stop(ref);
  }

  async reload ():Promise<void>{
    this.currentPage = 1;
    this.loadTransactions();
  }
  onPageChange(event: any) {
    this.pageSize=event.pageSize;
    this.currentPage = event.pageIndex+1;
    this.loadTransactions();
  }

  applyFilter() {
    if(this.filterValue===''){
      this.transactionsZelle=this.backTransactionCripto;
    }
    this.filteredTransactionCripto = this.transactionsZelle.filter(transaction => {
      const transactionValues = Object.values(transaction);
      const lowerCaseFilter = this.filterValue.toLowerCase();
      return transactionValues.some(value => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(lowerCaseFilter);
        }
        return false;
      });
    });
    this.transactionsZelle = this.filteredTransactionCripto;
  }

  private transaccionesIguales(transacciones1: TransferenciasUSDT[], transacciones2: TransferenciasUSDT[]): boolean {
    if (transacciones1.length !== transacciones2.length) {
      return false; // Si las longitudes son diferentes, las listas no son iguales
    }
    const transacciones1Ids = transacciones1.map((t) => t.idTransferencia);
    const transacciones2Ids = transacciones2.map((t) => t.idTransferencia);

    // Compara los identificadores de las transacciones
    for (const id of transacciones1Ids) {
      if (!transacciones2Ids.includes(id)) {
        return false; // Si un identificador en transacciones1 no está en transacciones2, no son iguales
      }
    }
    return true; // Si todas las comparaciones fueron iguales, las listas son iguales
  }

  openRejectTransactionModal(row: any) {
    const dialogRef = this.dialog.open(RejectTransactionModalComponent, {
      data: row,
      maxHeight: '70%',
      maxWidth: '826px',
      minWidth: '800px',
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if(result === true){
        this.loadTransactions();
      }
    });
  }

  openSendTransactionModal(row: any) {
    const dialogRef = this.dialog.open(SendTransactionsZelleModalComponent, {
      data: row,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if(result === true){
        this.loadTransactions();
      }
    });
  }

  openEditModal(row: any){
    const dialogRef = this.dialog.open(EditZelleTransactionComponent, {
      data: row,
      maxHeight: '70%',
      maxWidth: '826px',
      minWidth: '800px',
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if(result === true){
        this.loadTransactions();
      }
    });
  }

  toggleCard(id: number) {
    this.expandedCardId = this.expandedCardId === id ? null : id;
  }

  copy(element: TransferenciasUSDT){

    var text = '';
    text = `zelle:\n${element.beneficiario}\n${element.direccionZelle}\n${this.currencyPipe.transform(element.montoUSDT, '$')} usd`
    this.clipboard.copy(text);
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    })

    Toast.fire({
      icon: 'success',
      title: 'Transferencia copiada al portapapeles'
    })


  }

}
